module.exports = __webpack_public_path__ + "img/mobile_EN_CA.7838814e.png";